const noEmptyStringValidator = async (_, value) => {
  if (!value?.trim().length) throw new Error('Must not be an empty string');
  return true;
};

export { noEmptyStringValidator };
